import * as Sentry from '@sentry/browser'

// see docs: https://getsentry.github.io/sentry-javascript/

export function installSentry() {
  const { REACT_APP_SENTRY_DSN, REACT_APP_ENV, REACT_APP_RELEASE_ID } = process.env

  if (!REACT_APP_SENTRY_DSN) {
    console.warn('REACT_APP_SENTRY_DSN is undefined')
  } else {
    Sentry
      .init({
        dsn: REACT_APP_SENTRY_DSN,
        environment: REACT_APP_ENV,
        release: REACT_APP_RELEASE_ID,
        attachStackTrace: true,
      })
  }
}

export function logException(ex) {
  console.error(ex)

  typeof ex === 'string'
    ? Sentry.captureMessage(ex)
    : Sentry.captureException(ex)
}



// WEBPACK FOOTER //
// ./src/services/sentry.js